<template>
<section class="root display-mobile">
  <com-h1 title="演讲专题"></com-h1>
  <div class="tracks">
    <dl v-for="(track, id) in tracks" :key="id">
      <router-link :to="'/track/' + track.id" class="decription">
        <dt class="change">
          <h4><a :class="[track.isHotTopic?'active':'']">{{track.topic}}</a></h4>
          <i></i>
        </dt>
      </router-link>
      <!-- <router-link :to="'/track/' + track.id" class="decription" :style="{'max-height': show[id]?'500px':'0'}">
        <div class="inner">
          <div class="content" v-html="track.introduce">
          </div>
          <a class="more">专题详情 >></a>
        </div>
      </router-link> -->
    </dl>
  </div>
  <div class="box-button"><router-link :to="'/track'"><c-button>查看所有专题及演讲</c-button></router-link></div>
</section>
</template>

<script>
import ComH1 from '@/components/com-h1'
import CButton from 'gkConUI/com-button'

export default {
  components: {
    ComH1,
    CButton
  },
  props: ['tracks'],
  data () {
    let show = {}
    for (let id in this.tracks) {
      show[id] = false
    }
    return {
      curId: -1,
      show: show
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    toggle (id) {
      this.curId = this.curId === id ? -1 : id
      this.show[id] = !this.show[id]
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"

.root
  padding: 40px 0
.tracks
  position: relative
  margin: 30px 0
  dl:first-child
    border-top: 1px solid #ccc
  dt
    padding: 12px 4vw
    display: flex
    justify-content: space-between
    align-items: center
    background-color: #fff
    cursor: pointer
    border-bottom: 1px solid #ccc
    h4
      position: relative
      a
        color: $primary
        font-size: 16px
      .active
        &:after
          content: ''
          width: 36px
          height: 24px
          background-image: url(../../assets/hot-tag-m.png)
          background-size: 34px
          background-repeat: no-repeat
          background-position: center
          display: inline-block
          position: absolute
          right: -40px
          top: 0
    i
      float: right
      width: 15px
      height: 8px
      display: block
      background: url('./assets/down.jpg') no-repeat center
      background-size: contain
      transform: rotate(-90deg)
    i.active
      transform: rotate(180deg)
      // background: url('./assets/up.jpg') no-repeat center

.decription
  display: block
  transition: all $speed ease-in-out
  overflow: hidden
  // background-color: #f8f8f8
  .inner
    padding: 18px 4vw
    border-bottom: 1px solid #ccc
    > .more
      font-size: 12px
  .content
    font-size: 14px
    line-height: 1.5
    color: #333

</style>
